export const usdFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export function formatUSD(amount: number | null | undefined): string {
  if (amount === null || amount === undefined || Number.isNaN(Number(amount))) return 'N/A';
  return usdFormatter.format(Number(amount));
}

export function formatUSDMillions(amount: number | null | undefined): string {
  if (amount === null || amount === undefined || Number.isNaN(Number(amount))) return '';
  return `${usdFormatter.format(Number(amount))} M`;
}

export function formatDecimal(amount: number | null | undefined): number | string {
  if (amount === null || amount === undefined || Number.isNaN(Number(amount))) return 'N/A';
  if (amount < 10_000) {
    return Number(amount.toFixed(2));
  }
  return Math.round(amount);
}